import { request } from "./request.js";

async function get(key) {
    return await request("/room", { key: key }, "POST");
}

async function save(data) {
    return await request("/room/save", data, "POST");
}

async function list(all = false) {
    const append = all === true ? '?all' : '';
    return await request("/room/list" + append, {}, "POST");
}

export { save, get, list };